import { Component, Input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';


@Component({
  selector: 'app-issueInput-control-label-view, [app-issueInput-control-label-view]',
  templateUrl: './issueInput-control-label-view.component.html'
})
export class IssueInputControlLabelViewComponent {

  @Input() controlTemplate: ControlTemplate;

  constructor(
  ) {
  }

}
